import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import SurveyInBookingForm from "src/views/general/booking-components/survey/SurveyInBookingForm";

const Survey = ({
  hideThisSurvey,
  selectedOffer,
  errors,
  control,
  randomState,
  setRandomState,
  randomErrors,
  setRandomErrors,
  setValue,
  getValues,
  stepperGuideLength,
  isProcess,
  submitButtonRef,
  setError,
  surveysWithBookingFirst,
  customStyle,
}) => {
  const { t } = useTranslation();

  const checkSurveyFields = () => {
    let error = [];

    if (selectedOffer?.survey.length > 0) {
      selectedOffer?.survey.forEach((survey) => {
        if (survey?.questionslist.length > 0) {
          survey?.questionslist.forEach((item) => {
            let field = "";
            if (item.type === "question-short-answer") {
              field = `answer[_${item.id}][_${item.choices[0].id}`;
            }

            if (item.type === "question-comment-essay") {
              field = `answer[_${item.id}][_${item.choices[0].id}`;
            }

            if (item.type === "question-one-answer") {
              field = `answer[_${item.id}]`;
            }

            if (item.type === "question-multiple-answer") {
              field = `answer[_${item.id}]`;
            }

            if (item.type === "question-true-false") {
              field = `answer[_${item.id}]`;
            }

            if (item.type === "question-yes-no") {
              field = `answer[_${item.id}]`;
            }

            let current_value = getValues(field) ?? "";

            if (Boolean(item.is_required) && !current_value) {
              error = `question-${field}-is-required`;
              setError(field, {
                required: true,
                message: t("booking.error.required.question"),
              });
            }
          });
        }
      });
    }

    if (error.length > 0) {
      console.log("form has an error:");
      return;
    }

    submitButtonRef.current.click();
  };

  return (
    <>
      {/* additional survey */}
      {!hideThisSurvey && selectedOffer?.survey.length > 0 && (
        <SurveyInBookingForm
          selectedOffer={selectedOffer}
          errors={errors}
          control={control}
          randomState={randomState}
          setRandomState={setRandomState}
          randomErrors={randomErrors}
          setRandomErrors={setRandomErrors}
          setValue={setValue}
          getValues={getValues}
          stepperGuideLength={stepperGuideLength}
          handleBack={() => {}}
          surveysWithBookingFirst={surveysWithBookingFirst}
          customStyle={customStyle}
        />
      )}

      <Box
        sx={{
          mt: "30px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Button
          variant={"contained"}
          sx={{
            height: "48px",
            borderRadius: "12px",
            fontSize: "14px",
            backgroundColor: customStyle?.accentColor ?? "var(--color-black)",
            color: customStyle?.buttonTextColor ?? "#fff",
            border: "1px solid",
            borderColor: `${customStyle?.accentColor} !important`,

            "&:hover": {
              backgroundColor: `${customStyle?.accentColor} !important`,
              color: customStyle?.buttonTextColor ?? "#fff",
              border: "1px solid",
              borderColor: `${customStyle?.accentColor} !important`,
            },
          }}
          // onClick={() => submitButtonRef.current.click()}
          onClick={() => checkSurveyFields()}
          disabled={isProcess}
          startIcon={
            isProcess && <CircularProgress size={15} color="inherit" />
          }
        >
          {t(
            "individual.booking.schedule.choose_schedule.button.schedule_event"
          )}
        </Button>
      </Box>
    </>
  );
};

export default Survey;
